/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// actions
import {
    GET_COMMENTING_ADDONS_FETCHING,
    GET_COMMENTING_ADDONS_SUCCESS,
    GET_COMMENTING_ADDONS_ERROR,
    DISCARD_COMMENTING_ADDONS_SETTINGS,
    COMMENTING_ADDONS_SETTINGS_CHANGED,
    CREATE_COMMENTING_ADDONS_SETTING_SUCCESS,
    UPDATE_COMMENTING_ADDONS_SETTING_SUCCESS,
    UPDATE_COMMENTING_ADDONS_SETTING_ERROR,
    UPLOADING_IMAGE,
    STAND_ALONE_COMMUNITY_UPLOAD_IMAGE,
    STAND_ALONE_COMMUNITY_DISCARD_IMAGE
} from 'state/actions/commentingState/addOnsStatus';



/* ========== ~~~~~~~~~~ COMMENTING ADDONS STATE > COMMENTS STATUS: REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
    addOnsData: {
        commentsCounter: {
          uuid: "uuid",
          isCommentsCounterEnabled:  false,
          zeroCommentsLabel: {
              value: "Comments",
              valid: true
          },
          singleCommentLabel: {
              value: "1 Comment",
              valid: true
          },
          multipleCommentsLabel: {
              value: "{count} Comments",
              valid: true
          },
          headerCode: "",
          bodyCode: ""
        },
        community: {
          uuid: "uuid",
          isCommunityEnabled: false,
          title: {
              value: "",
              valid: false
          },
          showTopArticles: false,
          topArticlesInitialLoadLimit: 2,
          topArticlesDaysTimeFrame: {
              value: 0,
              valid: false
          },
          placeholderImageType: 'standard',
          placeholderImageUrl: "",
          showTopCommenters: false,
          topCommentersInitialLoadLimit: 2,
          code: "",
          isCustomColorEnabled: false,
          customColorSchema: {
            background: "FFFFFF",
            primaryText: "FFFFFF",
            secondaryText: "FFFFFF",
            branding: "FFFFFF",
            primaryButtonLabel: "FFFFFF",
            errorValidation: "FFFFFF"
          }
        }  
    },
    isSettingCreated: {
        commentsCounter: false,
        community: false
    },
    isSettingChanged: {
        commentsCounter: false,
        community: false
    },
    isCommunityColorsValid: true,
    previouslySavedData: null,
    isAddOnsSettingsChanged: false,
    getAddOnsFetching: true,
    getAddOnsSuccess: false,
    getAddOnsError: false,
    isAddOnsSettingsUpdated: false
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const addOnsStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_COMMENTING_ADDONS_FETCHING:
            newState.getAddOnsFetching = action.isFetching;
            newState = JSON.parse(JSON.stringify(defaultState));
            newState.isAddOnsSettingsChanged = false;
            newState.isSettingChanged = defaultState.isSettingChanged;
            newState.isCommunityColorsValid = true;
            return newState;
        case GET_COMMENTING_ADDONS_SUCCESS:
            newState.getAddOnsSuccess = true;
            if(action.data.commentsCounter) {
                newState.addOnsData.commentsCounter = action.data.commentsCounter;
                newState.isSettingCreated.commentsCounter = true;
                newState.addOnsData.commentsCounter.zeroCommentsLabel = {
                    value: action.data.commentsCounter.zeroCommentsLabel, 
                    valid: !!action.data.commentsCounter.zeroCommentsLabel
                }
                newState.addOnsData.commentsCounter.singleCommentLabel = {
                    value: action.data.commentsCounter.singleCommentLabel, 
                    valid: !!action.data.commentsCounter.singleCommentLabel
                }
                newState.addOnsData.commentsCounter.multipleCommentsLabel = {
                    value: action.data.commentsCounter.multipleCommentsLabel, 
                    valid: !!action.data.commentsCounter.multipleCommentsLabel
                }
            }
            if(action.data.community) {
                newState.addOnsData.community = action.data.community;
                newState.addOnsData.community.placeholderImageType = !action.data.community.placeholderImageUrl ? 'standard' : action.data.community.placeholderImageUrl === '' ? 'standard' : 'custom';
                newState.addOnsData.community.title = {value: action.data.community.title, valid: !!action.data.community.title}
                newState.addOnsData.community.topArticlesDaysTimeFrame = {
                    value: action.data.community.topArticlesDaysTimeFrame, 
                    valid: !!action.data.community.topArticlesDaysTimeFrame || action.data.community.topArticlesDaysTimeFrame === 0
                }
                newState.isSettingCreated.community = true;
            }
            newState.previouslySavedData = JSON.parse(JSON.stringify(newState.addOnsData));
            return newState;
        case GET_COMMENTING_ADDONS_ERROR:
            newState.getAddOnsError = true;
            newState = JSON.parse(JSON.stringify(defaultState));
            return newState;
        case DISCARD_COMMENTING_ADDONS_SETTINGS:
            if(!newState.isAddOnsSettingsUpdated) {
                newState.addOnsData = newState.previouslySavedData;
            }
            newState.addOnsData[action.addOnsType][action.ignoreProperty.name] = action.ignoreProperty.value;
            newState.isAddOnsSettingsChanged = false;
            newState.isSettingChanged[action.addOnsType] = false;
            return newState;
        case COMMENTING_ADDONS_SETTINGS_CHANGED:
            newState.isAddOnsSettingsUpdated = false;
            if(action.addOnsType) {
                newState.addOnsData[action.addOnsType][action.property] = action.value;
            } else {
                newState[action.property] = action.value;
            }
            newState.isSettingChanged[action.addOnsType]= true;
            return newState;
        case CREATE_COMMENTING_ADDONS_SETTING_SUCCESS:
            newState.isSettingCreated[action.addOnsType]= true;
            newState.addOnsData[action.addOnsType] = action.response.data;
            if(action.addOnsType === 'commentsCounter') {
                newState.addOnsData.commentsCounter.zeroCommentsLabel = {
                    value: action.response.data.zeroCommentsLabel, 
                    valid: !!action.response.data.zeroCommentsLabel
                }
                newState.addOnsData.commentsCounter.singleCommentLabel = {
                    value: action.response.data.singleCommentLabel, 
                    valid: !!action.response.data.singleCommentLabel
                }
                newState.addOnsData.commentsCounter.multipleCommentsLabel = {
                    value: action.response.data.multipleCommentsLabel, 
                    valid: !!action.response.data.multipleCommentsLabel
                }
            }
            newState.previouslySavedData = newState.addOnsData;
            return newState;
        case UPDATE_COMMENTING_ADDONS_SETTING_SUCCESS:
            newState.isImageChanged = false;
            newState.isAddOnsSettingsUpdated = true;
            newState.isSettingChanged[action.addOnsType] = false;
            newState.addOnsData.community.placeholderImageType = !newState.addOnsData.community.placeholderImageUrl ? 'standard' : newState.addOnsData.community.placeholderImageUrl === '' ? 'standard' : 'custom';
            newState.previouslySavedData = newState.addOnsData;
            return newState;
        case UPDATE_COMMENTING_ADDONS_SETTING_ERROR:
            newState.isAddOnsSettingsUpdated = false;
            newState.addOnsData = newState.previouslySavedData;
            return newState;
        case UPLOADING_IMAGE:
            newState.isUploadingImage = action.status;
            return newState;
        case STAND_ALONE_COMMUNITY_UPLOAD_IMAGE:
            newState.addOnsData.community.placeholderImageUrl = action.data.imageUrl;
            newState.isImageChanged = true;
            return newState;
        case STAND_ALONE_COMMUNITY_DISCARD_IMAGE:
            newState.addOnsData.community.placeholderImageUrl = action.data;
            newState.isImageChanged = true;
            return newState;
        default:
            return state;
    }
};

/* ++++++++++ --------------- CUSTOM METHODS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default addOnsStatus;
